import styled from "styled-components";
import { Flex, Box } from "@edricphan2022/uikit";
import mediaQueries from "../../@uikit/theme/base";

export const Wrapper = styled(Box)`
  width: 100%;
  position: relative;
  padding-top: 120px;
`;

export const OurChange = styled(Box)`
  width: 100%;
  height: 100%;
  margin-top: 48px;
  padding-top: 27px;
  padding-bottom: 48px;
  background-position: center;
  overflow: hidden;
  position: relative;
`;

